import { reduxForm } from "redux-form"
import { notification } from "antd"
import { ConfigProps } from "redux-form/lib/reduxForm"
import { IntlShape } from "react-intl"

export function appReduxForm<FormData, P, ErrorType = string>(
  config?: ConfigProps<FormData, P, ErrorType> | Partial<ConfigProps<FormData, P, ErrorType>>
) {
  return reduxForm<FormData, P & { intl?: IntlShape }, ErrorType>({
    ...config,
    onSubmitFail(errors, dispatch, submitError, props) {
      props.intl?.formatMessage &&
        notification.error({
          message: props.intl.formatMessage({ id: "form.validation.formNotFilled" }),
        })

      if (!props.intl) {
        console.log(
          "Missing intl prop in appReduxForm. Please provide intl prop to the form component."
        )
      }

      config?.onSubmitFail?.(errors, dispatch, submitError, props)
    },
  })
}
